import React from 'react';

import { Box } from '@betterment/samba-react';

import { SidebarAccountsQuery } from './graphql/query.sidebarAccounts.generated';

import { urlBuilder } from '../../../Shared/urlBuilder';
import { NavLink, navLinkStyles } from '../nav-link/NavLink';

type Envelope = SidebarAccountsQuery['envelopes'][number];
type Account = Envelope['accounts'][number];

const AccountItemContent: React.FC<{ account: Account; subtitle?: string }> = ({ account, subtitle }) => {
  return (
    <>
      <NavLink.Icon asChild={true}>
        <img src={account.icon.dark} alt="" />
      </NavLink.Icon>
      <Box css={{ display: 'flex', flexDirection: 'column' }}>
        <NavLink.Text>{account.name}</NavLink.Text>
        {subtitle && <NavLink.Subtext>{subtitle}</NavLink.Subtext>}
      </Box>
    </>
  );
};

export const AccountItem: React.FC<{ account: Account }> = ({ account }) => {
  const { url, subtitle } =
    account.__typename === 'CheckingAccount'
      ? {
          url: account.remote && urlBuilder.getAppCheckingSummary({ accountId: account.remote.checkingAccountId }),
          subtitle: account.remote ? undefined : 'Unavailable',
        }
      : { url: urlBuilder.appAccount({ accountId: account.id }), subtitle: undefined };

  return url ? (
    <NavLink
      key={account.id}
      className={navLinkStyles({ spacing: subtitle ? 'default' : 'expanded' })}
      to={url}
      data-turbolinks="false"
    >
      <AccountItemContent account={account} subtitle={subtitle} />
    </NavLink>
  ) : (
    <Box css={navLinkStyles.raw({ spacing: subtitle ? 'default' : 'expanded' })}>
      <AccountItemContent key={account.id} account={account} subtitle={subtitle} />
    </Box>
  );
};
